module.exports = __webpack_public_path__ + "966616e0eaf5347976a80e314960342a.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/996M.jpg
// module id = 686
// module chunks = 0